import Toast from "./toast"

const Tools = {

    eval(elements) {
        if (!this.isNotNull(elements)) {
            console.warn("elements is null")
            return false
        }
        let counter = 0
        for (let i = 0; i < elements.length; i++) {
            if (!this.isNotNull(elements[i])) {
                console.warn(`Element [${i}] is null`)
                counter++
            }
        }
        return counter == 0
    },

    validate: (elements, message) => {
        let counter = 0
        elements.forEach(element => {
            if (element == null) {
                counter++
            }
            else {
                if (element instanceof Array) {
                    if (element.length == 0) {
                        counter++
                    }
                }
                else if (element instanceof String) {
                    if (element == undefined || element == null || element == "") {
                        counter++
                    }
                }
                else {
                    if (element == undefined || element == null) {
                        counter++
                    }
                }
            }
        })
        if (counter != 0) {
            Toast.error(message)
            throw new Error(message)
        }
    },

    parse: (object) => {
        return JSON.stringify(object, null, 4)
    }
}

export default Tools